const bg = {
  pleaseEnterUsername: "Моля, въведете потребителско име",
  cannotFriendYourself: "Не можете да изпратите покана за приятелство на себе си.",
  friendRequestSent: "Поканата за приятелство е изпратена!",
  failedToSendRequest: "Неуспешно изпращане на заявката",
  linkCopied: "Връзката е копирана в клипборда!",
  backToInvites: "Назад към поканите",
  sendFriendRequestByUsername: "Изпрати покана за приятелство чрез потребителско име",
  enterUsername: "Въведете потребителско име",
  send: "Изпрати",
  yourInviteQrCode: "Вашият QR код за покана",
  inviteLink: "Връзка за покана",
  scanQrOrUseLink: "Сканирайте този QR код или използвайте тази връзка, за да изпратите покана за приятелство",
  copyInviteLink: "Копирай връзката за покана",
  goToItem: "Към елемента",
  verificationEmailSent: "Имейлът за потвърждение е изпратен! Проверете входящата си поща.",
  verificationEmailFailed: "Неуспешно изпращане на имейл за потвърждение. Опитайте отново.",
  verifyYourEmail: "Потвърдете имейла си",
  verifyEmailInstructions: "Моля, потвърдете имейл адреса си, за да получите достъп до акаунта си. Проверете входящата си поща за връзка за потвърждение.",
  sending: "Изпращане...",
  resendVerificationEmail: "Изпрати отново имейла за потвърждение",
  login: "Вход",
  register: "Регистрация",
  home: "Начало",
  calendar: "Календар",
  friends: "Приятели",
  profile: "Профил",
  logout: "Изход",
  loading: "Зареждане...",
  language: "Език",
  calendarSelectPlaceSuggestion: "Моля, изберете място от предложенията, за да бъдат прикачени координати.",
  calendarSelectDateAndTime: "Моля, изберете дата и час.",
  calendarPositiveDuration: "Моля, въведете положителна продължителност.",
  calendarFutureDateRequired: "Датата и часът на събитието трябва да са в бъдещето.",
  calendarCreateEventFailed: "Неуспешно създаване на събитие. Опитайте отново.",
  cancel: "Отказ",
  createNewEvent: "Създай ново събитие",
  week: "Седмица",
  month: "Месец",
  eventTitle: "Заглавие",
  date: "Дата",
  time: "Час",
  duration: "Продължителност",
  endsAt: "Завършва в",
  place: "Място",
  searchForPlace: "Търсене на място",
  placeSearchTip: "Съвет: започнете да въвеждате и изберете резултат, за да прикачите координати.",
  description: "Описание",
  createEvent: "Създай събитие",
  today: "Днес",
  previousMonth: "Предишен месец",
  nextMonth: "Следващ месец",
  previous: "Назад",
  next: "Напред",
  mondayShort: "Пон",
  tuesdayShort: "Вт",
  wednesdayShort: "Ср",
  thursdayShort: "Чет",
  fridayShort: "Пет",
  saturdayShort: "Съб",
  sundayShort: "Нед",
  more: "още",
  mustRespondWillBeforeReposting: "Трябва да отговорите „Ще присъствам“, преди да препубликувате",
  event: "Събитие",
  backToCalendar: "Назад към календара",
  addToGoogleCalendar: "Добави в Google Calendar",
  when: "Кога",
  where: "Къде",
  openLocationInGoogleMaps: "Отвори местоположението в Google Maps",
  hosts: "Организатори",
  yourResponse: "Вашият отговор",
  currentResponse: "Текущ отговор",
  response_will: "Ще присъствам",
  response_might: "Може би ще присъствам",
  response_wont: "Няма да присъствам",
  willRunIntoYou: "Ще мина",
  mightDropBy: "Може да мина",
  wontCome: "Няма да дойда",
  repostToMyFriends: "Сподели с приятелите ми",
  responses: "Отговори",
  willAttend: "Ще присъствам",
  reposted: "Споделено",
  mightAttend: "Може би ще присъствам",
  cancelEvent: "Отмени събитието",
  cancellationEmailNoticeBefore: "Хората, които са потвърдили участие",
  cancellationEmailNoticeAfter: "ще бъдат уведомени по имейл за отмяната.",
  optionalCancellationMessage: "Незадължително съобщение до участниците (максимум 1000 знака)",
  confirmCancelEvent: "Потвърди отмяната на събитието",
  clear: "Изчисти",
  confirmCancellation: "Потвърди отмяната",
  confirmCancellationMessage: "Сигурни ли сте, че искате да отмените това събитие? Това ще уведоми потвърдените участници и ще премахне събитието.",
  eventCancelledNotified: "Събитието е отменено. Уведомени:",
  attendees: "участници",
  failedToCancelEvent: "Неуспешна отмяна на събитието",
  back: "Назад",
  cancelled: "Отменено",
  ok: "ОК",
  forgotPassword: "Забравена парола",
  email: "Имейл",
  passwordResetLinkSent: "Ако акаунтът съществува, е изпратена връзка за нулиране.",
  passwordResetRequestFailed: "Неуспешна заявка за нулиране на парола.",
  sendResetLink: "Изпрати връзка за нулиране",
  addFriend: "Добави приятел",
  incomingRequests: "Входящи заявки",
  accept: "Приеми",
  deny: "Откажи",
  myFriends: "Моите приятели",
  noFriendsYet: "Все още нямате приятели. Започнете да добавяте!",
  seeProfile: "Виж профила",
  noEventsToRespondTo: "Няма събития за отговор",
  allCaughtUp: "Всичко е прегледано. Проверете по-късно за нови събития от приятели.",
  events: "Събития",
  unknown: "Неизвестно",
  noDescriptionProvided: "Няма предоставено описание.",
  will: "Ще",
  maybe: "Може би",
  wont: "Няма",
  userNotFound: "Потребителят не е намерен",
  friendRequestSentSuccessfully: "Поканата за приятелство е изпратена успешно!",
  friendInvitation: "Покана за приятелство",
  sendFriendRequest: "Изпрати покана за приятелство",
  loginToSendFriendRequest: "Моля, влезте, за да изпратите покана за приятелство",
  chooseLanguage: "Изберете език",
  invalidCredentials: "Невалидни данни за вход. Опитайте отново.",
  username: "Потребителско име",
  password: "Парола",
  forgotPasswordQuestion: "Забравихте паролата си?",
  dontHaveAccount: "Нямате акаунт?",
  registerHere: "Регистрирайте се тук",
  invalidProfilePhotoType: "Невалиден тип файл. Моля, качете JPEG, PNG, GIF или WebP изображение.",
  invalidFileExtension: "Невалидно файлово разширение",
  allowedExtensions: "Разрешени",
  fileTooLarge: "Файлът е твърде голям",
  maximumFileSize: "Максимум",
  profilePhotoRemoved: "Профилната снимка е премахната.",
  failedToRemoveProfilePhoto: "Неуспешно премахване на профилната снимка",
  profileUpdatedSuccessfully: "Профилът е обновен успешно!",
  failedToUpdateProfile: "Неуспешно обновяване на профила",
  privateEmailExplanation: "Само вие можете да виждате своя имейл, за да се избегнат нежелани съобщения извън платформата",
  yourEmailIsPrivate: "Вашият имейл е личен.",
  profilePhoto: "Профилна снимка",
  removePhoto: "Премахни снимката",
  firstName: "Име",
  lastName: "Фамилия",
  tellPeopleAboutYourself: "Разкажете за себе си",
  whereToContactMe: "Как да се свържат с мен",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Запази",
  notSet: "Не е зададено",
  editProfile: "Редактирай профила",
  imageToCrop: "Изображение за изрязване",
  zoom: "Мащабиране",
  usePhoto: "Използвай снимката",
  name: "Име",
  whereToContact: "Контакт",
  removeFriendship: "Премахни приятелството",
  confirmRemoveFriend: "Потвърди премахването на приятеля",
  confirmRemoveFriendBefore: "Сигурни ли сте, че искате да премахнете",
  confirmRemoveFriendAfter: "от списъка си с приятели?",
  friendRemoved: "Приятелят е премахнат.",
  failedToRemoveFriend: "Неуспешно премахване на приятеля.",
  confirmRemove: "Потвърди премахването",
  error: "Грешка",
  removed: "Премахнато",
  passwordsDoNotMatch: "Паролите не съвпадат",
  registrationFailed: "Регистрацията е неуспешна. Опитайте отново.",
  confirmPassword: "Потвърдете паролата",
  alreadyHaveAccount: "Вече имате акаунт?",
  loginHere: "Влезте тук",
  passwordResetSuccessfully: "Паролата е нулирана успешно.",
  failedToResetPassword: "Неуспешно нулиране на паролата.",
  resetPassword: "Нулиране на паролата",
  newPassword: "Нова парола",
  confirmNewPassword: "Потвърдете новата парола",
  setNewPassword: "Задайте новата парола",
  emailVerifiedSuccessfully: "Имейлът е потвърден успешно!",
  emailVerificationFailed: "Потвърждението е неуспешно. Връзката може да е невалидна или изтекла.",
  verifying: "Потвърждаване...",
  verified: "Потвърдено!",
  redirectingToHome: "Пренасочване към началната страница...",
  verificationFailed: "Потвърждението е неуспешно",
  goToHome: "Към началната страница",
  about: "Относно",
  aboutConceptTitle: "Концепция",
  aboutCreatorIntroduction: "Здравейте, аз съм Crypt0, катерач и създател на Run Into Me.",
  aboutCreatorStory: "Създадох сайта, защото обичам да общувам с други катерачи и прекарвах твърде много време в организиране на срещи.",
  aboutPlanningProblem: "Исках да уведомявам всички едновременно кога и къде ще катеря, без официална покана.",
  aboutDeveloperSolution: "Тогава си спомних, че съм разработчик и мога сам да направя решение.",
  aboutWelcome: "Добре дошли в Run Into Me, където приятелите ви виждат дейности, към които могат да се присъединят без напрежение.",
  aboutCallToAction: "Публикувайте тук следващата дейност, която е по-забавна заедно!",
  aboutTutorialTitle: "Ръководство",
  aboutCalendarCreateEvent: "Екранът „Календар“ служи и за създаване на ново събитие.",
  aboutEventColorsIntroduction: "Цветовете показват участието ви:",
  aboutColorGold: "Златно",
  aboutColorGoldDescription: "Вие сте организатор.",
  aboutColorGreen: "Зелено",
  aboutColorGreenDescription: "Ще присъствате.",
  aboutColorOrange: "Оранжево",
  aboutColorOrangeDescription: "Отговорили сте „може би“.",
  aboutColorBlue: "Синьо",
  aboutColorBlueDescription: "Още не сте отговорили.",
  aboutColorGray: "Сиво",
  aboutColorGrayDescription: "Отказали сте поканата.",
  aboutCalendarEventDetails: "Изберете събитие за подробности и отговор.",
  aboutFriendPageTitle: "Страница „Приятели“",
  aboutFriendPageDescription: "Въведете потребителско име или изпратете покана / QR код.",
  aboutHomePageTitle: "Начална страница",
  aboutHomePageDescription: "Прегледайте предстоящите събития и посочете дали ще присъствате.",
  aboutRepostScreenTitle: "Екран за споделяне",
  aboutGoogleCalendarDescription: "Добавете събитието в Google Календар с този бутон.",
  aboutRepostDescription: "След потвърждение можете да споделите събитието с приятелите си.",
};

export default bg;